import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef90cf1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My Level", -1))
const _hoisted_4 = { class: "col-xl-6 mt-5 mt-xl-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Stickers", -1))
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My Active Products", -1))
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "When you begin a learning activity, it will show up here!", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Explore All Products ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_student_rank = _resolveComponent("student-rank")!
  const _component_new_stickers = _resolveComponent("new-stickers")!
  const _component_course_card = _resolveComponent("course-card")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_student_rank, { rank: _ctx.rank }, null, 8, ["rank"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_new_stickers)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.recentCourses.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentCourses, (course) => {
              return (_openBlock(), _createElementBlock("div", {
                key: course.id,
                class: "col-lg-6 col-xl-4"
              }, [
                _createVNode(_component_course_card, {
                  course: course,
                  "course-name-in-button": false
                }, null, 8, ["course"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
    ]),
    _createVNode(_component_router_link, {
      to: { name: _ctx.routeNames.courses },
      class: "btn btn-secondary me-2 font-weight-bold"
    }, {
      default: _withCtx(() => [
        _hoisted_12,
        _createVNode(_component_font_awesome_icon, {
          class: "ms-2",
          size: "sm",
          icon: "arrow-right"
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}